import { render, staticRenderFns } from "./Single-Delivery-Detail.vue?vue&type=template&id=17479f3a"
import script from "./Single-Delivery-Detail.vue?vue&type=script&lang=js"
export * from "./Single-Delivery-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports